export const SignatoryState = {
  Authorised: "Authorised",
  Submitted: "Submitted",
  Rejected: "Rejected",
};